import CustomButton from "components/buttons/CustomButton";
import excelIcon from "resources/img/excelIcon.png";
// import style from "./ExcelDownloadButton.module.css";
import { style } from "components/buttons/AdminCustomButton";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import AdminCustomButton from "components/buttons/AdminCustomButton";

function ExcelDownloadButton(props) {
  // const {header, list, fileName} = props;
  const { empty = [], output, data, indexes } = props;

  // const exportToExcel = () => {
  //     let array = new Array();
  //     list.map((row, index) => {
  //         let obj = {};
  //         header.map((headerCol) => {
  //             obj[headerCol.text] = row[headerCol.code];
  //         })
  //         array.push(obj);
  //     })
  //     const worksheet = XLSX.utils.json_to_sheet(array);
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //     const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

  //     function s2ab(s) {
  //         const buffer = new ArrayBuffer(s.length);
  //         const view = new Uint8Array(buffer);
  //         for (let i = 0; i < s.length; i++) {

  //             view[i] = s.charCodeAt(i) & 0xFF;
  //         }
  //         return buffer;
  //     }

  //     saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), `${fileName}_${getToday()}.xlsx`);
  // };
  const title = output?.getTitle
    ? output?.getTitle({ data: data, indexes: indexes })
    : indexes.length === 0
    ? "전체 다운로드"
    : "선택 다운로드";
  const pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
  const _ = require("lodash");
  const calcWidth = (text) =>
    ([...`${text}`]?.reduce(
      (pre, acc) => pre + (pattern.test(acc) ? 17.5 : 10),
      0
    ) +
      11) /
      1.15 || 0;

  const exportToExcel = async () => {
    const { style, header, list, fileName, onSuccess } = (await output?.getData(
      data,
      indexes
    )) || {
      header: [],
      list: [],
      fileName: undefined,
      style: {},
      onSuccess: () => {},
    };
    let array = [];
    let wpx = header.map((headerCol) => ({ wpx: calcWidth(headerCol.text) }));

    list.forEach((row, index) => {
      let obj = {};
      header.forEach((headerCol, ColIndex) => {
        let value;
        if (headerCol.Cell) {
          value = headerCol.Cell({
            row: row,
            cell: row[headerCol.code],
            index: index,
          });
        } else {
          value = row[headerCol.code] !== undefined ? row[headerCol.code] : "";
        }
        // if (headerCol.type === "number") value = Number(value);

        // obj[headerCol.text] = {
        //   v: value,
        //   s: _.merge(
        //     {},
        //     style?.common,
        //     style?.col,
        //     headerCol?.style?.common,
        //     headerCol?.style?.col
        //   ),
        //   // z: headerCol.type === "number" ? "0" : "@",
        // };
        obj[headerCol.text] = _.merge(
          {
            v: value,
            s: _.merge(
              {},
              style?.common,
              style?.col,
              headerCol?.style?.common,
              headerCol?.style?.col
            ),
            // z: headerCol.type === "number" ? "0" : "@",
          },
          typeof value === "number" ? { t: "n" } : {}
        );
        wpx[ColIndex] = {
          wpx: Math.max(wpx?.[ColIndex]?.wpx || 0, calcWidth(value)),
        };
      });
      array.push(obj);
    });

    // 변환된 배열을 이용하여 엑셀 파일을 생성합니다.
    // const worksheet = XLSX.utils.json_to_sheet(array);
    const head = {};
    header.forEach(
      (headerCol) =>
        (head[headerCol.text] = {
          v: headerCol.text,
          s: _.merge(
            {},
            style?.common,
            style?.header,
            headerCol?.style?.common,
            headerCol?.style?.header
          ),
        })
    );
    const worksheet = XLSX.utils.json_to_sheet(
      [
        ...empty,
        //   {
        //     [header[0].text]: {
        //       v: "엑셀 업로드 양식(전자세금계산서-일반(영세율))",
        //     },
        //   },
        //   { [header[0].text]: { v: "" } },
        //   { [header[0].text]: { v: "" } },
        //   { [header[0].text]: { v: "" } },
        //   { [header[0].text]: { v: "" } },
        head,
        ...array,
      ],
      { skipHeader: true }
    );

    // 너비 적용
    worksheet["!cols"] = wpx;
    // 헤더 스타일 적용
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // XLSXStyle.apply_style(workbook, worksheet);
    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

    // 이진 데이터를 Blob으로 변환하는 함수입니다.
    function s2ab(s) {
      const buffer = new ArrayBuffer(s.length);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buffer;
    }

    // Blob을 이용하여 사용자가 파일을 다운로드 할 수 있게 합니다.
    saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      `${fileName}.xlsx`
    );

    if (onSuccess.constructor.name === "Function") onSuccess?.(list);
    else await onSuccess?.(list);
  };

  const getToday = () => {
    var date = new Date();
    var year = date.getFullYear();
    var month = ("0" + (1 + date.getMonth())).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);

    return year + "-" + month + "-" + day;
  };

  return (
    <AdminCustomButton
      text={title}
      style={style.white}
      // className={style.button}
      icon={<img src={excelIcon} alt="exel" />}
      onClick={exportToExcel}
    />
  );
}

export default ExcelDownloadButton;

// 리스트 그대로 출력하기
// function ExcelDownloadButton(props) {
//     const {list, fileName} = props;

//     const exportToExcel = () => {
//         const worksheet = XLSX.utils.json_to_sheet(list);

//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
//         const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

//         function s2ab(s) {
//             const buffer = new ArrayBuffer(s.length);
//             const view = new Uint8Array(buffer);
//             for (let i = 0; i < s.length; i++) {
//                 view[i] = s.charCodeAt(i) & 0xFF;
//             }
//             return buffer;
//         }

//         saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), `${fileName}_${getToday()}.xlsx`);
//     };

//     const getToday = () => {
//         var date = new Date();
//         var year = date.getFullYear();
//         var month = ("0" + (1 + date.getMonth())).slice(-2);
//         var day = ("0" + date.getDate()).slice(-2);

//         return year + "-" + month + "-" + day;
//     }

//     return (
//         <CustomButton text={"엑셀 다운로드"} className={style.button} icon={<img src={excelIcon} />} onClick={exportToExcel}/>
//     );
// }
